import { render } from "./StudentsReviews.vue?vue&type=template&id=5f30f0e0&scoped=true&ts=true"
import script from "./StudentsReviews.vue?vue&type=script&lang=ts"
export * from "./StudentsReviews.vue?vue&type=script&lang=ts"

import "./StudentsReviews.vue?vue&type=style&index=0&id=5f30f0e0&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f30f0e0"]])

export default __exports__